import React, { useEffect, useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { isLocalStorageNearFull, getLocalStorageUsagePercent } from '../../utils/storageQuota';
/**
 * StorageWarningBanner — Surfaces localStorage quota warnings to users.
 *
 * Shows a dismissible warning banner when localStorage usage exceeds 80%.
 * Checks on mount and every 60 seconds thereafter.
 *
 * Addresses: RES-4 (storageQuota.ts not surfaced to users)
 */
export function StorageWarningBanner() {
  const [dismissed, setDismissed] = useState(false);
  const [usagePercent, setUsagePercent] = useState(0);
  const [isNearFull, setIsNearFull] = useState(false);
  useEffect(() => {
    function check() {
      setIsNearFull(isLocalStorageNearFull());
      setUsagePercent(getLocalStorageUsagePercent());
    }
    check();
    const interval = setInterval(check, 60000);
    return () => clearInterval(interval);
  }, []);
  if (!isNearFull || dismissed) return null;
  const isCritical = usagePercent > 95;
  return <div role="alert" className={`flex items-center gap-3 px-4 py-2.5 text-sm ${isCritical ? 'bg-red-50 text-red-800 border-b border-red-200' : 'bg-amber-50 text-amber-800 border-b border-amber-200'}`} data-id="element-2357">
      <AlertTriangle className="h-4 w-4 flex-shrink-0" data-id="element-2358" />
      <span className="flex-1" data-id="element-2359">
        {isCritical ? 'Opslag bijna vol — gegevens kunnen verloren gaan. Neem contact op met je leerkracht of beheerder.' : `Opslag raakt vol (${usagePercent}% gebruikt). Overweeg oude gegevens op te ruimen.`}
      </span>
      <button onClick={() => setDismissed(true)} className={`p-1 rounded-md hover:bg-black/5 ${isCritical ? 'text-red-600' : 'text-amber-600'}`} aria-label="Sluiten" data-id="element-2360">
        <X className="h-4 w-4" data-id="element-2361" />
      </button>
    </div>;
}